import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './ToggleButtons.scss';

const ToggleButtons = (props) => {
  const getClass = btn => classnames({
    btn: true,
    'btn-primary': btn.active,
    'btn-outline': !btn.active,
    'btn-small': props.small,
  });

  return (
    <div className="toggle-buttons">
      {props.buttons.map(btn => (
        <button
          key={btn.label}
          className={`btn-selector ${getClass(btn)}`}
          onClick={() => props.onToggle(btn)}
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleButtons;

ToggleButtons.propTypes = {
  small: PropTypes.bool,
  buttons: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onToggle: PropTypes.func,
};

ToggleButtons.defaultProps = {
  small: undefined,
};
